export class PagedResult<T> {
    items: T[];
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
   
    constructor(
      items: T[] = [],
      totalCount: number = 0,
      totalPages: number = 0,
      pageNumber: number = 0,
      pageSize: number = 0,
      hasNextPage: boolean = false,
      hasPreviousPage: boolean = false
    ) {
      this.items = items;
      this.totalCount = totalCount;
      this.totalPages = totalPages;
      this.pageNumber = pageNumber;
      this.pageSize = pageSize;
      this.hasNextPage = hasNextPage;
      this.hasPreviousPage = hasPreviousPage;
    }

    getStartIndex() : number {
      return (this.pageNumber - 1) * this.pageSize + 1;
    }

    getEndIndex() : number {
      let endIndex = this.pageNumber * this.pageSize;
      if (endIndex > this.totalCount) {
          endIndex = this.totalCount;
      }
      return endIndex;
    }
  }
  